import React, {useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import { fetchWithAuth } from "../utils/fetchWithAuth";
import {useAuth} from "../contexts/authContext";
import FeedbackForm from "../components/FeedbackForm";

const DeleteAccountPage = () => {
  const [confirmText, setConfirmText] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const [showFeedback, setShowFeedback] = useState(false);
  const [userNickname, setUserNickname] = useState('');
  const { isLoggedIn, setIsLoggedIn, userEmail, setUserEmail } = useAuth();

  useEffect(() => {
    const nickname = localStorage.getItem("nickname");
    if (nickname) setUserNickname(nickname);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("nickname");
    localStorage.removeItem("usage_count");
    localStorage.removeItem("daily_limit");
    setIsLoggedIn(false);
    setUserEmail("");
    alert("로그아웃 되었습니다.");
    navigate("/login");
  };


  const handleDelete = async () => {
    if (confirmText !== "회원탈퇴") {
      setMessage("정확히 '회원탈퇴' 라고 입력해야 탈퇴할 수 있습니다.");
      return;
    }

    try {
      const res = await fetchWithAuth(`/user/delete`, {
        method: "DELETE",
      });

      if (res.ok) {
        localStorage.removeItem("token");
        localStorage.removeItem("email");
        localStorage.removeItem("nickname");
        localStorage.removeItem("usage_count");
        localStorage.removeItem("daily_limit");
        setMessage("탈퇴가 완료되었습니다.");
        setTimeout(() => {
          window.location.href = "/";
        }, 2000);
      } else {
        const data = await res.json();
        setMessage(`❌ ${data.detail || "탈퇴 실패"}`);
      }
    } catch (err) {
      setMessage("서버 오류가 발생했습니다.");
    }
  };

  return (
       <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-white">
        <header
            className="w-full flex flex-col md:flex-row justify-between items-center px-4 py-4 border-b bg-white dark:bg-gray-800">
          <div className="text-center md:text-left mb-4 md:mb-0">
            <h1 className="text-xl font-bold text-blue-600 dark:text-blue-300">J_Universe</h1>

            <nav className="mt-2 text-sm">
              <Link to="/" className="hover:text-blue-400">J_Universe</Link>
              <span className="mx-2">|</span>
            </nav>
          </div>

          <div className="flex flex-col items-end gap-2 mt-4 md:mt-0">
            {isLoggedIn && (
                <div className="text-sm font-semibold text-green-300 text-center md:text-right w-full">
                  어서오세요, <span className="text-yellow-400">{userNickname}</span> 님
                </div>
            )}
            <div className="flex gap-2">
              {isLoggedIn ? (
                  <button
                      onClick={handleLogout}
                      className="px-4 py-2 text-sm font-semibold bg-red-500 text-white rounded-full">
                    Sign out
                  </button>
              ) : (
                  <Link
                      to="/login"
                      className="px-4 py-2 text-sm font-semibold bg-blue-500 text-white rounded-full">
                    Sign in
                  </Link>
              )}
               {!isLoggedIn && (
                <Link
                  to="/signup"
                  className="px-4 py-2 text-sm font-semibold text-white bg-green-500 rounded-full"
                >
                  Sign up
                </Link>
              )}
              {isLoggedIn && (
                <Link
                  to="/mypage"
                  className="px-4 py-2 text-sm font-semibold text-white bg-green-500 rounded-full"
                >
                  MyPage
                </Link>
              )}
            </div>
          </div>
        </header>
        <div className="max-w-md mx-auto mt-10 p-6 bg-gray-300 shadow rounded-lg">
          <h2 className="text-xl font-bold text-center mb-4 text-black ">회원 탈퇴</h2>
          <p className="text-sm text-gray-600 mb-2">
            정말 탈퇴하시겠습니까? 아래 입력란에 <strong>회원탈퇴</strong> 를 정확히 입력해주세요.
          </p>
          <input
            type="text"
            placeholder="회원탈퇴"
            className="w-full p-2 border rounded mb-3"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
          />
          <button
            onClick={handleDelete}
            className="w-full py-2 bg-red-600 text-white font-semibold rounded hover:bg-red-700"
          >
            계정 삭제
          </button>
          {message && <p className="mt-4 text-center text-sm text-red-500">{message}</p>}
        </div>
    </div>
  );
};

export default DeleteAccountPage;
